<template>
    <div>
        <v-flex>
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2"  v-on="on">Nuevo tipo de cita</v-btn>
                    </template>
                    <create @create="create"></create>
                </v-dialog>
            </v-toolbar>
        </v-flex>

        <v-flex>

            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogEdit" max-width="500px">
                    <edit @edit="edit" ref="edit"></edit>
                </v-dialog>
            </v-toolbar>
        </v-flex>

        <v-card>
            <v-card-title>
                Tipos de citas
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="assemblies"
              :search="search"
              :loading="loadingTable"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.description }}</td>
                    <td class="text-xs-center" :class="props.item.status == 1 ? '' : ''">{{ props.item.status == 0 ? 'inActiva' : 'Activa' }}</td>
                    <td class="text-xs-center">
                        <v-tooltip top>
                            <v-icon
                              medium
                              class="mr-2"
                              @click="editItem(props.item)"
                              slot="activator"
                            >
                                edit
                            </v-icon>
                            <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-icon
                              medium
                              @click="deleteItem(props.item)"
                              slot="activator"
                            >
                                delete
                            </v-icon>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>
    </div>

</template>
<script>
    import axios from 'axios'
    import Form from 'vform';
    import create from "./create.vue";
    import edit from "./edit.vue";

    export default {
        name: 'quotes-category-show',
        components: {create, edit},
        data() {
            return {
                dialogEdit: false,
                form: new Form({
                    description: ''
                }),
                search: '',
                headers: [
                    { text: 'Descripcion', align: 'center', value: 'description' },
                    { text: 'Estado', align: 'center', value: 'status' },
                    { text: 'Acción', align: 'center', value: 'assembly_date', sortable: false }
                ],
                assemblies: [],
                dialogAssembly: '',
                dialogIdAssembly: 0,
                dialog: false,
                userNameMaxLength: 60,
                entries: [],
                isLoading: false,
                currentMemberSearch: null,
                searchBoardMembers: null,
                boardMembersHeaders: [
                    { text: 'Actions', value: 'name', sortable: false, align: 'center' }
                ],
                boardMembers: [],
                boardMembersSearch: '',
                showCreateMemberForm: false,
                createMemberForm: new Form({
                    name: ''
                }),
                loadingTable: false,
            }
        },
        created() {
            this.getCategorysList()
        },
        methods: {
            edit (){
                this.getCategorysList()
                this.dialogEdit = false
            },
            create (){
                this.dialog=false
                this.getCategorysList()
            },
            async getCategorysList() {
                //this.loadingTable = true;
                const { data } = await axios.get('/api/qoute/category/show')
                console.log(data);
                this.assemblies = data;
                //this.loadingTable = false;
            },
            editItem(item) {
                this.dialogEdit = true
                this.$refs.edit.created(item.id)
            },
            async deleteItem(item) {
                await axios.delete(`/api/qoute/category/${item.id}` , {id: item.id})
                  .then(resp=>{
                      this.getCategorysList()
                  })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/quoteCategory/show.vue